import type { Cue } from '@core/model/cue.ts';

/**
 * Copied from extension overlayRenderer (getRenderText).
 * `dualMode` true → source + translation; false → translation when translated, else source.
 */
export function getRenderText(
  cue: Cue,
  dualMode: boolean,
  options: { loadingText: string; speakingMode: boolean },
): string {
  if (cue.loading) return options.loadingText;

  if (cue.dictation) {
    const text = options.speakingMode ? cue.text : cue.dictation;
    return dualMode ? `${text}${cue.translation ? `\n${cue.translation}` : ''}` : text;
  }

  if (cue.translated) {
    if (dualMode) {
      return `${cue.kuroshiro ?? cue.text}${cue.translation ? `\n${cue.translation}` : ''}`;
    }
    return cue.translation ?? '';
  }

  return cue.kuroshiro ?? cue.text;
}
